import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

export class SelectedText {
  value!: string;
  start!: number;
  end!: number;
  fullText?: string;
}

@Directive({
  selector: '[tccMonoTextSelection]',
})
export class TextSelectionDirective {
  private _selectedText: SelectedText | null = null;

  /** id van de container waarbinnen selectie toegestaan is */
  @Input() parentNodeId!: string;

  /** emit naar parent component (GameComponent) */
  @Output() textSelected = new EventEmitter<SelectedText>();

  @HostListener('document:selectionchange')
  onSelectionChange(): void {
    const sel = window.getSelection();
    if (!sel || sel.isCollapsed) {
      this._selectedText = null;
      return;
    }

    const container = this.parentNodeId ? document.getElementById(this.parentNodeId) : null;
    if (!container) { this._selectedText = null; return; }

    // beide uiteinden moeten binnen de container vallen
    if (!container.contains(sel.anchorNode) || !container.contains(sel.focusNode)) {
      sel.removeAllRanges();
      this._selectedText = null;
      return;
    }

    const start = Math.min(sel.anchorOffset, sel.focusOffset);
    const end   = Math.max(sel.anchorOffset, sel.focusOffset);

    this._selectedText = {
      value: sel.toString(),
      start,
      end,
      fullText: sel.anchorNode?.textContent || ''
    };
  }

  @HostListener('mouseup')    onMouseUp()  { this.wrapAndEmit(); }
  @HostListener('touchend')   onTouchEnd() { this.wrapAndEmit(); }

  /** Wrap selectie → emit payload → clear selection */
  private wrapAndEmit(): void {
    if (!this._selectedText) return;

    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const container = document.getElementById(this.parentNodeId);
    const range = sel.getRangeAt(0);

    if (!container || !container.contains(range.commonAncestorContainer)) {
      sel.removeAllRanges();
      this._selectedText = null;
      return;
    }

    // geselecteerde DOM-fragment
    const frag = range.extractContents();

    // nested highlights binnen het fragment eerst “unwrappen”
    const inner = (frag as ParentNode).querySelectorAll?.('span.highlight');
    inner?.forEach((el) => el.replaceWith(document.createTextNode(el.textContent || '')));

    // highlight wrapper (met attrs voor jouw ‘kruisje’-undo)
    const span = document.createElement('span');
    span.className = 'highlight';
    span.setAttribute('start', String(this._selectedText.start));
    span.setAttribute('end',   String(this._selectedText.end));
    span.appendChild(frag);

    // plaats de highlight
    range.insertNode(span);

    // opruimen
    sel.removeAllRanges();
    container.normalize();

    // emit naar parent
    this.textSelected.emit(this._selectedText);
    this._selectedText = null;
  }
}
